export default class {
    error(type, method) {
        throw new Error(type + ' type has to have a ' + method + ' method');
    }
    render() {
        this.error('Box', 'render');
    }
}
